import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleAccountManager } from "../hooks/roles/ProtectedRoleAccountManager";
import React from "react";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";

const ErrorPage = React.lazy(() => import("../components/error-page"));
const TareaDetalleGestionarTareaProgramada = React.lazy(
  () =>
    import(
      "../components/task/accountManager/tareaDetalleGestionarTareaProgramada/tarea-detalle-gestionar-tarea-programada"
    )
);
export function tareaDetalleGestionarTareaProgramada() {
  return (
    <Route
      path="/tarea-detalle-gestionar-tarea-programada"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleAccountManager>
              <LazySuspense>
                <TareaDetalleGestionarTareaProgramada />
              </LazySuspense>
            </ProtectedRoleAccountManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
